import React from 'react';
import './PageHeader.scss';

const PageHeader = ({ title, subtitle, breadcrumb, image, hideText = false }) => {
  return (
    <div className={`page-header-wrapper${hideText ? ' page-header--no-text' : ''}`}>
      <div className="page-header-background">
        <img 
          src={image || '/assets/IMG/fond.jpeg'} 
          alt="" 
          className="bg-image"
        />
      </div>
      {!hideText && (
        <div className="page-header-content">
          {breadcrumb && (
            <div className="breadcrumb">
              {breadcrumb.map((item, index) => (
                <span key={index}>
                  {item}
                  {index < breadcrumb.length - 1 && <span className="separator"> / </span>}
                </span>
              ))}
            </div>
          )}
          <h1>{title}</h1>
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
